import { useTranslation } from "react-i18next";
import { MapPin, Pencil, Trash2 } from "lucide-react";
import { TherapistSpace } from "../../domain/types";

interface SpaceCardProps {
    space: TherapistSpace;
    onEdit: (space: TherapistSpace) => void;
    onDelete: (space: TherapistSpace) => void;
    isDeleting?: boolean;
}

export default function SpaceCard({
    space,
    onEdit,
    onDelete,
    isDeleting = false,
}: SpaceCardProps) {
    const { t } = useTranslation();

    return (
        <article className="flex items-start justify-between gap-3 rounded-xl border border-gray-200 p-4 dark:border-gray-700">
            <div className="flex flex-col gap-1">
                <h4 className="text-sm font-semibold">{space.name}</h4>
                {space.address && (
                    <p className="flex items-center gap-1 text-xs text-gray-500">
                        <MapPin size={12} aria-hidden="true" />
                        {space.address}
                    </p>
                )}
                {space.notes && (
                    <p className="text-xs text-gray-500">{space.notes}</p>
                )}
            </div>
            <div className="flex items-center gap-2">
                <button
                    type="button"
                    onClick={() => onEdit(space)}
                    aria-label={t("scheduler.settings.editSpace", {
                        name: space.name,
                    })}
                >
                    <Pencil size={16} />
                </button>
                <button
                    type="button"
                    disabled={isDeleting}
                    onClick={() => onDelete(space)}
                    aria-label={t("scheduler.settings.deleteSpace", {
                        name: space.name,
                    })}
                    className="text-red-500 disabled:opacity-50"
                >
                    <Trash2 size={16} />
                </button>
            </div>
        </article>
    );
}
